import { useAuth } from 'lib/auth'
import { flags, useFeatureFlags } from 'lib/feature-flags'

export const VIRTUAL_COACHING_REQUESTS_PATH = '/pga-coach/virtual-coaching'

// The flag alone decides whether the Virtual Coaching requests surfaces exist,
// so coaches without Coach+ can find them and see the upgrade callout.
export const useVirtualCoachingFlag = () => {
  const [isFlagEnabled] = useFeatureFlags([
    flags.FLAG_FEAT_COACH_VIRTUAL_COACHING,
  ])
  return Boolean(isFlagEnabled)
}

// The flag and a Coach+ plan decide whether a coach can actually use Virtual
// Coaching: sell the offering, load requests, and see ready requests on the dashboard.
export const useVirtualCoachingEnabled = () => {
  const { user } = useAuth()
  const isFlagEnabled = useVirtualCoachingFlag()
  return isFlagEnabled && Boolean(user?.coach?.hasPaidTierSubscription)
}
